// extracted by mini-css-extract-plugin
module.exports = {"container":"_0fce717cdb--container--rSOM9","icon":"_0fce717cdb--icon--Eunq0","remoteness":"_0fce717cdb--remoteness--JTRsN"};